import { LogoMark } from "@/components/site/Logo";

export const AuthFrame = ({ title, eyebrow, children, testid }) => (
  <div className="grid min-h-screen md:grid-cols-2" data-testid={testid}>
    <div className="grain relative hidden flex-col justify-between bg-[#0B0B0B] p-12 text-white md:flex">
      <LogoMark className="h-12 w-12" />
      <h2 className="font-wide text-6xl font-black uppercase leading-[0.9] tracking-tight">Manage<br />the <span className="text-[#FFC400]">catalogue.</span></h2>
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Tide Inchem · Admin</p>
    </div>
    <div className="flex items-center justify-center px-5 py-16">
      <div className="w-full max-w-sm">
        <LogoMark className="h-10 w-10 md:hidden" />
        <p className="mt-6 font-mono text-xs uppercase tracking-[0.25em] text-zinc-700 md:mt-0">{eyebrow}</p>
        <h1 className="font-wide mt-3 text-3xl font-black uppercase tracking-tight">{title}</h1>
        {children}
      </div>
    </div>
  </div>
);

export const authField = "w-full border border-black/20 bg-white px-4 py-3.5 text-base outline-none transition-colors focus:border-[#FF5A00]";
export const authLabel = "block font-mono text-xs uppercase tracking-[0.15em] text-zinc-700";
export const authButton = "mt-8 flex w-full items-center justify-center gap-2 bg-[#0B0B0B] px-6 py-4 font-mono text-xs uppercase tracking-[0.18em] text-white transition-colors hover:bg-[#FF5A00] disabled:opacity-60";
